// removed by extract-text-webpack-plugin
module.exports = {"defaultHeaderTotalHeight":"68","mstTableBtnWrapMarginTop":"6","mstTableBtnWrapMarginBottom":"10","defaultResponsiveWidth":"900"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/_variables.scss
// module id = MejJ
// module chunks = 1